export default __webpack_public_path__ + "static/media/hvr-flip.37b735dc.svg";